import styled from 'styled-components';
import { BLACK, BLUE, CRIMSON_500 } from "@styles/colors";
import { INTER } from "@styles/fonts";
import { safeAreaInset } from '@lib/telegram';

// RupiahInput styled components
export const RupiahInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  color: ${BLACK};
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  cursor: pointer;
`;

export const AmountLabel = styled.span`
  font-family: ${INTER.medium};
`;

export const AmountContainer = styled.div`
  font-family: ${INTER.semiBold};
  font-size: 16px;
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 8px;
  position: relative;
`;

export const CurrencySymbol = styled.span`
  color: ${BLUE};
`;

export const ErrorMessage = styled.span`
  color: ${CRIMSON_500};
  font-size: 13px;
`;

export const KeyboardContainer = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
  padding: 16px 12px 24px 12px;
  padding-bottom: ${safeAreaInset().bottom || 24}px;
`;

export const MaxButton = styled.span`
  color: ${BLUE};
  font-family: ${INTER.semiBold};
  cursor: pointer;
  position: absolute;
  font-size: 14px;
  right: 12px;
`